const element = document.getElementById('profileAppEnv');
if (element) {
  const currency = element.getAttribute('data-currency');

  if (currency) {
    window.sharedEnvConfig = {
      ...window.sharedEnvConfig,
      currency
    };
  }
}
export const env: string = (element && element.getAttribute('env-val')) || 'None';
